import { Button, Modal } from "@etframework/ui.components";
import { useRef, useState } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import useModalEvent from "../../hooks/useModalEvent";
import { toast } from "react-toastify";
import { useDeleteMultipleTaskTemplates } from "../../data/mutations/taskTemplateMutations";
import useEvent from "../../hooks/useEvent";

export const DeleteTaskTemplateConfirmationModal = () => {
  const { t } = useTranslation(["DeleteTaskTemplateConfirmationModal"]);
  const modalRef = useRef(null);
  const [templates, setTemplates] = useState([]);
  const [visible, setVisible] = useState(false);

  const { ModalEvents, useRegisterEvent } = useModalEvent();
  const { mutate: deleteMultipleTaskTemplates } =
    useDeleteMultipleTaskTemplates();
  const { Events, toggleEvent } = useEvent();

  useRegisterEvent(ModalEvents.DeleteTaskTemplateModal, (e) => {
    setTemplates(e.detail ?? []);
    setVisible(true);
  });

  const onSubmit = () => {
    const deleteTaskTemplates = {
      TaskTemplatesIds: templates?.map((taskTemplate) => taskTemplate?.Id),
    };

    deleteMultipleTaskTemplates(
      { taskTemplates: deleteTaskTemplates },
      {
        onSuccess: () => {
          toast.success(
            t("DeleteTaskTemplateMsg", { count: templates?.length }),
            {
              position: "bottom-left",
            }
          );
          toggleEvent(Events.RefreshTaskTemplateGrid);
          setVisible(false);
        },
        onError: () => {
          toast.error(t("ErrorMsg", { count: templates?.length }), {
            position: "bottom-left",
          });
        },
      }
    );
  };

  const close = () => {
    setVisible(false);
    setTemplates([]);
  };

  const ModalFooter = () => {
    return (
      <>
        <div className="d-flex gap-3 justify-content-end py-4 px-4">
          <Button
            className={"btn-tertiary w-auto m-0 me-1"}
            onClick={() => modalRef.current.close()}
            text={t("Cancel")}
          />
          <Button
            onClick={onSubmit}
            className={"btn btn-danger bg-et-red et-white w-auto m-0"}
            text={t("DeleteBtn", {
              template: templates?.[0]?.Name,
              count: templates?.length,
            })}
          />
        </div>
      </>
    );
  };

  return ReactDOM.createPortal(
    <Modal
      ref={modalRef}
      isModal
      close={close}
      visible={visible}
      footerTemplate={ModalFooter}
      content={
        <>
          <div className="fs-16 fw-600 text-center">
            {t("Header", { count: templates?.length })}
          </div>
          <div className="text-center">
            {t("Message", {
              template: templates?.[0]?.Name,
              count: templates?.length,
            })}
          </div>

          {templates?.length > 0 && (
            <div className="mt-4 mx-2 mb-2 bg-light rounded p-2">
              {t("Templates", { count: templates?.length })}
              <span className="fw-600">
                {templates.map((x) => x.Name).join(", ")}
              </span>
            </div>
          )}
        </>
      }
      buttons={[{ foo: "bar" }]} //for the footer template
    />,
    document.body
  );
};
